const PromoPlanStyle = theme => ({ container: { padding: theme.spacing(1, 5, 2, 1) } });

export default PromoPlanStyle;
